import React from 'react';
import { PRODUCT_COMP_CD } from '@common/constants';

const HomeMainPCShortcut = ({ openLink }) => {
  const {
    channelInfo: { cdVal },
  } = $hooks.useUser();

  // compCd: 1 - kbstar, 2 - curex, galips
  const linkInfo = {
    1001: ['kbstar', 'galips'],
    1002: ['kbstar', 'curex'],
    1007: ['kbstar'],
    1011: ['kbstar'],
  };
  const displayLinks = linkInfo[cdVal] || [];

  return (
    <div className="shortcutLink">
      <p className="text-info2 ico-type">
        아래 사이트를 선택하시면 바로 이동 가능합니다.
      </p>

      <ul className="link-wrap two">
        {displayLinks.includes('kbstar') && (
          <li>
            <button onClick={() => openLink(PRODUCT_COMP_CD.kb)}>
              <div>
                <strong>스타 DREAM</strong>
                <span>구. KB생명 시스템</span>
              </div>
              <span className="ico arrow" />
            </button>
          </li>
        )}

        {displayLinks.includes('curex') && (
          <li className="old">
            <button onClick={() => openLink(PRODUCT_COMP_CD.cm)}>
              <div>
                <strong>CuREX</strong>
                <span>구. 푸르덴셜 시스템</span>
              </div>
              <span className="ico arrow" />
            </button>
          </li>
        )}

        {displayLinks.includes('galips') && (
          <li className="old">
            <button onClick={() => openLink(PRODUCT_COMP_CD.cm)}>
              <div>
                <strong>GALiPS</strong>
                <span>구. 푸르덴셜 시스템</span>
              </div>
              <span className="ico arrow" />
            </button>
          </li>
        )}
      </ul>
    </div>
  );
};

export default HomeMainPCShortcut;
